import MAdmin from './admin.menu'
import MFSOfficer from './fso.menu'
import MASManager from './asm.menu'
import MRSManager from './rsm.menu'
import MMKOfficer from './mkm.menu'
import MAudit from './audit.menu'
import MAccountant from './accountant.menu'

export const getSidebarMenus = user => {
  switch (user.role) {
    case 'admin': {
      return MAdmin
    }
    case 'fso': {
      return MFSOfficer
    }
    case 'asm': {
      return MASManager
    }
    case 'rsm': {
      return MRSManager
    }
    case 'mkm': {
      return MMKOfficer
    }
    case 'audit': {
      return MAudit
    }
    case 'accountant': {
      return MAccountant
    }
    default: {
      return []
    }
  }
}
